  /**
  * @description: 前后端数据交互http接口定义
  * @author: longzhiyong
  * @createTime: longzhiyong(2019-07-26)
  * @updateTime: name(xxxx-xx-xx)
  */

import axios from 'axios'
//import util from "../common/util";
import API_USER from "@/api/api_user";

//用于判断访问token是否刷新，不能少
window.isReresh = false;

axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';//配置请求头

//添加一个请求拦截器，在http访问头添加访问token
axios.interceptors.request.use(function (config) {

  // 读取本地缓存的accessToken，添加到http访问请求头
  let accessToken = sessionStorage.getItem('accessToken');
  if (accessToken) {
    config.headers.Authorization = accessToken;
  }
  //打印显示config配置对象所有的属性和方法
  //console.dir(config);
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// 添加一个响应拦截器
// 去掉登陆页面，临时注释代码 begin
axios.interceptors.response.use(function (response) {
  const data = response.data;
  // switch(data.code){
  //   case '500':
  //     console.log("token过期"+data.code);
  // }

  //console.dir(response);
  if (data.errorCode === 501) {
   //调用刷新token的接口
   let params = {
      refreshToken: sessionStorage.getItem('refreshToken')
    }
    API_USER.tokenRefresh(params).then((res) => {
      console.log('chhres', res)
      if (res.errorCode === 0) {
        sessionStorage.removeItem('accessToken')
        sessionStorage.setItem('accessToken', res.accessToken)
        response.config.headers.Authorization = res.accessToken
        location.reload()
      } else {
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('refreshToken');
        sessionStorage.removeItem('expiresIn');
        location.reload()
      }
      return axios(response.config)
    })
  }
  return response;
}, function (error) {
  // Do something with response error
  return Promise.reject(error);
});

//基地址
let base = '';  //接口代理地址参见：config/index.js中的proxyTable配置

//通用方法 POST定义
export const POST = (url, params) => {
  return axios.post(`${base}${url}`, params).then(res => res.data)
}

//通用方法 GET定义
export const GET = (url, params) => {
  return axios.get(`${base}${url}`, {params: params}).then(res => res.data)
}

//通用方法PUT定义
export const PUT = (url, params) => {
  return axios.put(`${base}${url}`, params).then(res => res.data)
}

//通用方法DELETE定义
export const DELETE = (url, params) => {
  return axios.delete(`${base}${url}`, {params: params}).then(res => res.data)
}

//通用方法PATCH定义
export const PATCH = (url, params) => {
  return axios.patch(`${base}${url}`, params).then(res => res.data)
}

export const O_POST = (url, params, responseType) => {
  return axios.post(`${base}${url}`, params, responseType).then(res=>res.data)
}

export const UPLOAD_POST = (url, params) => {
  return axios.post(`${base}${url}`, params, {
    headers: {
    'Content-Type': 'multipart/form-data'
    }
}).then(res=>res.data)
}


// WEBPACK FOOTER //
// ./src/api/index.js